/* WP-P50 (03.10.2026): Newsletter-Felder (Footer, Newsletter-Seite) -> Klaviyo-Liste "Newsletter" (TTNtnN, Double-Opt-in,
   loest die Willkommens-Serie aus). Klaviyo Client Subscriptions API mit oeffentlichem Schluessel (company_id) — kein Geheimnis. */
(function () {
  if (window.__vhKlaviyoNl) return; window.__vhKlaviyoNl = true;
  var COMPANY = 'WDLqTu', LISTE = 'TTNtnN';
  function meldung(box, text, ok) {
    var m = box.querySelector('.vh-nl-meldung');
    if (!m) { m = document.createElement('p'); m.className = 'vh-nl-meldung'; m.setAttribute('role', 'status'); box.appendChild(m); }
    m.textContent = text; m.style.cssText = 'margin:10px 0 0;font-size:15px;line-height:1.45;color:' + (ok ? '#2f6b37' : '#a0352b');
  }
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f.matches || !f.matches('form[data-vh-nl]')) return;
    ev.preventDefault();
    var box = f.closest('[data-vh-nl-box]') || f.parentNode;
    var mail = (f.querySelector('input[type=email]') || {}).value || '';
    var check = box.querySelector('input[type=checkbox]');
    if (check && !check.checked) { meldung(box, 'Bitte bestätigen Sie kurz, dass Sie den Newsletter erhalten möchten.', false); check.focus(); return; }
    var btn = f.querySelector('button'); if (btn) btn.disabled = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: f.getAttribute('data-vh-nl') || 'vitalhemp.de',
        profile: { data: { type: 'profile', attributes: { email: mail.trim() } } } },
        relationships: { list: { data: { type: 'list', id: LISTE } } } } })
    }).then(function (r) {
      if (r.status >= 200 && r.status < 300) {
        f.reset(); if (check) check.checked = false;
        meldung(box, 'Fast geschafft: Bitte bestätigen Sie Ihre Anmeldung über den Link in der E-Mail, die wir Ihnen gerade geschickt haben.', true);
      } else { throw new Error(r.status); }
    }).catch(function () {
      meldung(box, 'Das hat leider nicht geklappt. Bitte prüfen Sie die E-Mail-Adresse oder versuchen Sie es später noch einmal.', false);
    }).then(function () { if (btn) btn.disabled = false; });
  });
})();
